module.exports = kolibriGlobal.coreVue.components.KModal;